import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule, PipesModule } from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';
import { IntegrationComponent } from './integration.component';
import { IntegrationErrorComponent } from './error/integration-error.component';
import { IntegrationService } from './integration.service';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    TranslateModule.forChild(),
    PipesModule,
    WebbrokerCoreModule
  ],
  declarations: [
    IntegrationComponent,
    IntegrationErrorComponent
  ],
  exports: [
    IntegrationComponent,
    IntegrationErrorComponent
  ],
  providers: [
    IntegrationService
  ]
})
export class IntegrationModule {
}

export {
  IntegrationComponent,
  IntegrationErrorComponent
};
